import React, { useState } from 'react';
import { Label } from 'reactstrap';
import Table from 'reactstrap/lib/Table';

interface Props {
    columns: any[];
    data: any[];
}

const UnitManagementTable = (props: Props) => {
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });

    const handleSort = (key: any) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...props.data].sort((a, b) => {
        if (sortConfig.direction === 'asc') {
            return a[sortConfig.key] > b[sortConfig.key] ? 1 : -1;
        }
        if (sortConfig.direction === 'desc') {
            return a[sortConfig.key] < b[sortConfig.key] ? 1 : -1;
        }
        return 0;
    });

    return (
        <div className='card unit-table-container'>
            <Table bordered={true} className='unit-table'>
                <thead>
                    <tr>
                        {props.columns &&
                            props.columns.map((col, i) => (col && !col.isHide) && (
                                <th
                                    key={`th-col-${i}`}
                                    style={{ minWidth: `${col.width}px`, maxWidth: `${col.width}px`, cursor: 'pointer' }}
                                    onClick={() => handleSort(col.key)}
                                >
                                    {sortConfig.key === col.key && sortConfig.direction === 'asc' && (
                                        <span style={{ paddingRight: '4px' }}>
                                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.400241 7H7.60045C7.67334 6.99973 7.7448 6.97623 7.80712 6.93203C7.86944 6.88784 7.92027 6.82461 7.95413 6.74916C7.988 6.67371 8.00361 6.5889 7.9993 6.50385C7.99498 6.4188 7.97091 6.33674 7.92965 6.26649L4.32955 0.188987C4.18035 -0.0629957 3.82114 -0.0629957 3.67153 0.188987L0.0714315 6.26649C0.0297603 6.33659 0.00532331 6.41869 0.000775592 6.50389C-0.00377212 6.58908 0.0117434 6.67409 0.0456364 6.7497C0.0795294 6.82531 0.130504 6.88862 0.193021 6.93275C0.255538 6.97687 0.327207 7.00013 0.400241 7Z" fill="black" />
                                            </svg>
                                        </span>
                                    )}
                                    {sortConfig.key === col.key && sortConfig.direction === 'desc' && (
                                        <span style={{ paddingRight: '4px' }}>
                                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.67063 6.7984C3.70733 6.86057 3.75644 6.91141 3.81372 6.94653C3.871 6.98165 3.93475 7 3.99946 7C4.06417 7 4.12791 6.98165 4.1852 6.94653C4.24248 6.91141 4.29158 6.86057 4.32828 6.7984L7.92857 0.73215C7.97024 0.662181 7.99468 0.580228 7.99922 0.495195C8.00377 0.410163 7.98826 0.325302 7.95436 0.249833C7.92047 0.174365 7.86949 0.111175 7.80697 0.0671292C7.74445 0.0230835 7.67278 -0.000133618 7.59974 5.78465e-07H0.399176C0.326308 0.000351679 0.2549 0.0238674 0.192632 0.0680186C0.130364 0.11217 0.079592 0.175286 0.0457757 0.25058C0.0119594 0.325874 -0.00362155 0.410497 0.000708374 0.495348C0.0050383 0.580199 0.0291153 0.662067 0.0703501 0.73215L3.67063 6.7984Z" fill="black" />
                                            </svg>
                                        </span>
                                    )}
                                    {col.name}

                                </th>
                            ))}
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((data, i) => (
                        <tr key={`tr-col-${i}`}>
                            {props.columns &&
                                props.columns.map((col, i2) => (col && !col.isHide) && (
                                    <td
                                        key={`td-col-${i2}`}
                                        style={{ minWidth: `${col.width}px`, maxWidth: `${col.width}px` }}
                                    >
                                        {col.renderColumn ? (
                                            col.renderColumn(data, true)
                                        ) : (
                                            <Label>{`${data[col.key]}`}</Label>
                                        )}
                                    </td>

                                ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default UnitManagementTable;


// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/UnitManagementTable.tsx